// Tour catalog — the single registry the engine reads. Order here is the
// natural onboarding order (orientation first, then the three journeys).
import { orientation } from './orientation.js';
import { j1Lifecycle } from './j1-lifecycle.js';
import { j2DataToDecision } from './j2-data-to-decision.js';
import { j3FirstWeek } from './j3-first-week.js';

export const TOURS = Object.freeze([orientation, j1Lifecycle, j2DataToDecision, j3FirstWeek]);

const TOURS_BY_ID = Object.freeze(
  Object.fromEntries(TOURS.map((tour) => [tour.id, tour])),
);

/** Look up a tour definition by id; null when unknown. */
export function getTour(tourId) {
  if (!tourId) return null;
  return TOURS_BY_ID[tourId] || null;
}

/** All tour ids, in onboarding order. */
export function listTourIds() {
  return TOURS.map((tour) => tour.id);
}
